import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { FilterButton } from 'Components/frameworks/filter-button/FilterButton';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  choices: Array<{
    icon?: IconName;
    isDisabled?: boolean;
    isIconOnly?: boolean;
    isSelected?: boolean;
    label: ReactNode;
    value: string;
  }>;
  className?: string;
  name: string;
  onChange: (name: string, checked: boolean, value: string | boolean) => void;
  title?: string;
};
export const ChoiceList = ({ choices = [], className, name, onChange, title }: Props) => (
  <fieldset className={classnames('m-0 flex flex-col gap-y-20 border-0 p-0', className)}>
    {title && <legend className="mb-10 p-0 text-16 font-bold leading-normal">{title}</legend>}
    {choices.length > 0 && (
      <ul className="flex flex-wrap gap-20">
        {choices.map((choice) => (
          <li className="flex items-center gap-10" key={choice.value}>
            {choice.icon && <Icon className="text-sienna" name={choice.icon} width="1.5rem" />}
            <FilterButton
              isActive={!!choice.isSelected}
              isIconButton={choice.isIconOnly}
              isDisabled={choice.isDisabled}
              onClick={() => {
                onChange(name, !choice.isSelected, choice.value);
              }}
            >
              {choice.label}
            </FilterButton>
          </li>
        ))}
      </ul>
    )}
  </fieldset>
);
